import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/i18n";
import { Reveal } from "@/lib/motion";

export default function Sampling() {
  const { t } = useLang();
  return (
    <section data-testid="sampling-section" className="relative overflow-hidden bg-[#0A0A0A] border-y border-white/10">
      {/* Feature image on the right */}
      <div className="absolute inset-y-0 right-0 w-1/2 hidden lg:block">
        <img src="/images/p1.jpg" alt="Componente lucidato di precisione" className="w-full h-full object-cover" style={{ filter: "grayscale(0.4) brightness(0.45)" }} />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A] via-[#0A0A0A]/60 to-transparent" />
      </div>
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_20%_50%,rgba(212,175,55,0.10),transparent_55%)]" />

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 py-24 lg:py-32">
        <div className="max-w-2xl">
          <Reveal>
            <span className="font-accent text-xs md:text-sm tracking-[0.25em] uppercase text-[#D4AF37]">{t.sampling.tag}</span>
            <h2 className="mt-6 font-display text-4xl md:text-6xl lg:text-7xl font-semibold tracking-tighter text-white leading-[0.95]">
              {t.sampling.title}
            </h2>
          </Reveal>
          <Reveal delay={0.12}>
            <p className="mt-8 text-base md:text-lg text-zinc-300 leading-relaxed max-w-lg">{t.sampling.text}</p>
          </Reveal>
          <Reveal delay={0.2}>
            <motion.a
              href="#contact"
              data-testid="sampling-cta"
              className="btn-fill mt-10 inline-flex items-center gap-3 border border-[#D4AF37] px-8 py-4 font-accent text-sm uppercase tracking-widest text-[#D4AF37] hover:text-black"
              whileHover={{ x: 4 }}
            >
              {t.sampling.cta} <ArrowRight size={18} />
            </motion.a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
